export interface UserState {
    username?: string;
    userId?: string;
    email?: string;
    nickname?: string;
    mobile?: string;
    mobileRegion?: string;
    hasPassword: boolean;
    hasWeixin: boolean;
    chineseNickname?: string;
    isAgree?: boolean;
}
const userInfo = defineStore(
    'user',
    () => {
        const userState = ref<UserState>({
            username: '',
            isAgree: false,
            userId: undefined,
            chineseNickname: undefined,
            email: '',
            mobile: undefined,
            mobileRegion: undefined,
            nickname: undefined,
            hasWeixin: false,
            hasPassword: false,
        });
        const clearUserInfo = () => {
            userState.value = {
                username: '',
                isAgree: userState.value.isAgree, // 保留用户已同意协议的勾选状态
                userId: undefined,
                email: '',
                mobile: undefined,
                mobileRegion: undefined,
                nickname: undefined,
                hasWeixin: false,
                hasPassword: false,
            };
        };
        const setUserInfo = (userInfo: any) => {
            userState.value = userInfo;
        };
        const setUserNickName = (nickname: string) => {
            userState.value.chineseNickname = nickname;
        };
        const setUserAgree = (isAgree: boolean) => {
            userState.value.isAgree = isAgree;
        };
        const userName = computed(() => userState.value.username);
        const userId = computed(() => userState.value.userId);
        const userNickName = computed(() => userState.value.chineseNickname);
        const userAgree = computed(() => userState.value.isAgree);
        return {
            clearUserInfo,
            setUserInfo,
            userState: userState,
            userName,
            userId,
            userNickName,
            setUserNickName,
            userAgree,
            setUserAgree,
        };
    },
    {
        // 开启持久化（默认使用 localStorage）
        // persist: {
        //     storage: localStorage,
        //     key: 'user-store',
        //     paths: ['userId', 'userName'], // 只持久化 userState
        // },
    }
);

export default userInfo;
